module.exports = __webpack_public_path__ + "a4787bca8fb16deb9d6ddce0325cb92c.MP3";